import { Instance, types } from 'mobx-state-tree'
import DialogStore from './dialog-store'

export const DialogsStore = types.model('DialogsStore', {
  reportsDialog: types.optional(DialogStore, {}),
})

export default DialogsStore

export interface IDialogsStore extends Instance<typeof DialogsStore> {}
